import { render, staticRenderFns } from "./UtilsPanel.vue?vue&type=template&id=1204b50e&scoped=true&"
import script from "./UtilsPanel.vue?vue&type=script&lang=js&"
export * from "./UtilsPanel.vue?vue&type=script&lang=js&"
import style0 from "./UtilsPanel.vue?vue&type=style&index=0&id=1204b50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1204b50e",
  null
  
)

export default component.exports